import * as Yup from 'yup';
import EntrySchema from './EntrySchema';

export const PostFormSchema = Yup.object().shape({
  date: Yup.date().required(),
  location: Yup.string().required(),
  logs: Yup.array().of(EntrySchema).default([])
});

const PostSchema = Yup.object().shape({
  date: Yup.string().matches(/^(\d{4}-\d{2}-\d{2})|(\d{2}\/\d{2}\/\d{4})$/).required(),
  location: Yup.string().required(),
  logs: Yup.array().of(EntrySchema).default([])
});

export default PostSchema;
